/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import SurveyQuestionList from '../survey-question-list/survey-question-list';
import { Breadcrumb } from '@g17eco/types/surveyScope';
import { ScopeQuestionOptionalValue, SurveyModelMinData } from '@g17eco/types/survey';
import { convertToFilters } from '@utils/survey/useScopeFilters';
import { standards } from '@g17eco/core';
import { findMatchingConfig, sortItemsByTypeCode, sortItemsByUtrSortingOrder } from '@utils/sortSurvey';
import { ViewValues } from '@g17eco/types/surveyOverview';

interface ScopeQuestionListProps {
  surveyData: SurveyModelMinData,
  questions: ScopeQuestionOptionalValue[],
  view: ViewValues;
  breadcrumbs: Breadcrumb[];
}

export const shouldShowScopeQuestions = (cardGroup: ViewValues) => [
  ViewValues.StandardsQuestionList,
].includes(cardGroup);

export const ScopeQuestionList = (props: ScopeQuestionListProps) => {
  const { surveyData, questions, view, breadcrumbs } = props;

  const filters = convertToFilters(view, breadcrumbs);
  // Find filter where value is a valid standard code (original group entry point)
  const filter = filters.find(f => f.value && standards[f.value]);
  const alternativeCode = filter?.value ?? '';

  // First item of filters should be the group tag
  const groupTag = filters?.[0]?.value;
  // Last item of filters should be the current group view from the breadcrumbs
  const currentView = filters?.[filters.length - 1]?.value;
  const order =
    groupTag && currentView
      ? findMatchingConfig(surveyData.utrSortingConfigMap?.[groupTag], currentView)?.order
      : undefined;
  const sortedQuestions = order
    ? sortItemsByUtrSortingOrder(questions, order)
    : sortItemsByTypeCode(questions, alternativeCode);

  return <SurveyQuestionList
    surveyGroups={[{
      groupName: '',
      list: sortedQuestions
    }]}
    alternativeCode={alternativeCode}
    surveyId={surveyData._id}
    unitConfig={surveyData.unitConfig}
    initiativeId={surveyData.initiativeId}
  />
}
